<!-- Not authorized-->
<div class="misc-wrapper">
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
  </a>
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">You are not authorized! 🔐</h2>
      <p class="mb-2">
        You are not authorized to access this page.
      </p>
      <a class="btn btn-primary mb-1 btn-sm-block" href="#/dashboard" rippleEffect
        >Back to dashboard</a
      ><img
        class="img-fluid"
        [src]="
          coreConfig.layout.skin === 'dark'
            ? 'assets/images/pages/not-authorized-dark.svg'
            : 'assets/images/pages/not-authorized.svg'
        "
        alt="Not authorized page"
      />
    </div>
  </div>
</div>
<!-- / Not authorized-->
